import React, { useState } from 'react';
import axios from 'axios';
import { 
  FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaPaperPlane, 
  FaSpinner, FaCogs, FaBox, FaHeadset 
} from 'react-icons/fa';
import API_CONFIG from '../config';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service_type: 'saas_demo',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });

  const showNotification = (message, type = 'success') => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: '', type: '' });
    }, 5000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    
    if (e.target.name === 'service_type') {
      const subjects = {
        'saas_demo': 'Senidek Sales & Inventory - Demo Request',
        'erp_consultation': 'Custom ERP - Consultation Request',
        'support': 'Technical Support Request',
        'sales': 'Sales Inquiry',
        'other': 'General Inquiry'
      };
      setFormData(prev => ({
        ...prev,
        subject: subjects[e.target.value] || 'General Inquiry'
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;

    if (!name || !email || !subject || !message) {
      showNotification('Please fill all required fields.', 'error');
      return;
    }

    if (!email.includes('@') || !email.includes('.')) {
      showNotification('Please enter a valid email address.', 'error');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${API_CONFIG.baseURL}${API_CONFIG.endpoints.contact}`,
        formData,
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        showNotification('✅ Message sent successfully! Our team will contact you within 24 hours.', 'success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          service_type: 'saas_demo',
          subject: 'Senidek Sales & Inventory - Demo Request',
          message: ''
        });
      } else {
        showNotification('❌ Error: ' + (response.data.error || 'Something went wrong'), 'error');
      }
    } catch (error) {
      console.error('Contact form error:', error);
      showNotification('❌ Connection error. Please try again.', 'error');
    }

    setLoading(false);
  };

  return (
    <div className="contact page-enter">
      {notification.show && (
        <div className={`notification-toast ${notification.type}`}>
          <span>{notification.message}</span>
        </div>
      )}

      <div className="contact-header">
        <span className="contact-badge">📬 Get in Touch</span>
        <h2>Request a <span>Service</span></h2>
        <p>Choose the service you're interested in and we'll get back to you</p>
      </div>

      <div className="service-cards">
        <div 
          className={`service-card ${formData.service_type === 'saas_demo' ? 'active' : ''}`}
          onClick={() => {
            setFormData({
              ...formData,
              service_type: 'saas_demo',
              subject: 'Senidek Sales & Inventory - Demo Request'
            });
          }}
        >
          <div className="service-icon"><FaBox /></div>
          <h4>Senidek Sales & Inventory</h4>
          <p>Request a demo of our SaaS solution</p>
          <ul>
            <li>✓ Inventory Management</li>
            <li>✓ Sales Analytics</li>
            <li>✓ Real-time Reports</li>
          </ul>
          <span className="service-select-btn">Select</span>
        </div>

        <div 
          className={`service-card ${formData.service_type === 'erp_consultation' ? 'active' : ''}`}
          onClick={() => {
            setFormData({
              ...formData,
              service_type: 'erp_consultation',
              subject: 'Custom ERP - Consultation Request'
            });
          }}
        >
          <div className="service-icon"><FaCogs /></div>
          <h4>Custom ERP Development</h4>
          <p>Get a custom ERP solution for your business</p>
          <ul>
            <li>✓ Tailor-made Solutions</li>
            <li>✓ Enterprise Security</li>
            <li>✓ Scalable Architecture</li>
          </ul>
          <span className="service-select-btn">Select</span>
        </div>

        <div 
          className={`service-card ${formData.service_type === 'support' ? 'active' : ''}`}
          onClick={() => {
            setFormData({
              ...formData,
              service_type: 'support',
              subject: 'Technical Support Request'
            });
          }}
        >
          <div className="service-icon"><FaHeadset /></div>
          <h4>Technical Support</h4>
          <p>Get help with your existing solutions</p>
          <ul>
            <li>✓ 24/7 Availability</li>
            <li>✓ Expert Assistance</li>
            <li>✓ Quick Response</li>
          </ul>
          <span className="service-select-btn">Select</span>
        </div>
      </div>

      <div className="contact-wrapper">
        <div className="contact-info-box">
          <h3>Contact Information</h3>
          <p>Reach out to us for any inquiries about our products and services.</p>
          
          <div className="contact-info-item">
            <div className="contact-icon-wrapper">
              <FaMapMarkerAlt />
            </div>
            <div>
              <h4>Visit Us</h4>
              <p>Addis Ababa, Ethiopia</p>
            </div>
          </div>
          
          <div className="contact-info-item">
            <div className="contact-icon-wrapper">
              <FaPhone />
            </div>
            <div>
              <h4>Call Us</h4>
              <p>+251 99 706 7274</p>
            </div>
          </div>
          
          <div className="contact-info-item">
            <div className="contact-icon-wrapper">
              <FaEnvelope />
            </div>
            <div>
              <h4>Email Us (Senidek)</h4>
              <p>support@senidektechnologies.com</p>
            </div>
          </div>
          
          <div className="contact-info-item">
            <div className="contact-icon-wrapper">
              <FaClock />
            </div>
            <div>
              <h4>Working Hours</h4>
              <p>Mon-Fri: 9:00 AM - 6:00 PM</p>
            </div>
          </div>

          <div className="contact-cta">
            <p>📞 Need immediate assistance?</p>
            <a href="tel:+251997067274" className="btn-outline call-btn">
              <FaPhone /> Call Now
            </a>
          </div>
        </div>

        <div className="contact-form-box">
          <h3>Send us a Message</h3>
          <p className="form-subtitle">Fill in the form and we'll get back to you</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Full Name *"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email Address *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number (Optional)"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="form-group">
              <select
                name="service_type"
                value={formData.service_type}
                onChange={handleChange}
                required
              >
                <option value="saas_demo">🖥️ Senidek Sales & Inventory - Demo Request</option>
                <option value="erp_consultation">⚙️ Custom ERP - Consultation</option>
                <option value="support">🛠️ Technical Support</option>
                <option value="sales">💰 Sales Inquiry</option>
                <option value="other">📝 Other</option>
              </select>
            </div>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Tell us about your requirements... *"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className="btn-primary submit-btn" disabled={loading}>
              {loading ? (
                <>
                  <FaSpinner className="spinner" /> Sending...
                </>
              ) : (
                <>
                  <FaPaperPlane /> Send Request
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <style>{`
        .contact { padding: 10px 0 30px; position: relative; }
        .notification-toast {
          position: fixed;
          top: 20px;
          right: 20px;
          padding: 16px 24px;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          z-index: 9999;
          max-width: 450px;
          box-shadow: 0 8px 30px rgba(0,0,0,0.15);
          animation: slideInRight 0.5s ease;
        }
        .notification-toast.success { background: linear-gradient(135deg, #059669, #10b981); }
        .notification-toast.error { background: linear-gradient(135deg, #dc2626, #ef4444); }
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        .contact-header { text-align: center; margin-bottom: 40px; }
        .contact-badge {
          display: inline-block;
          background: var(--primary-light);
          color: var(--primary);
          padding: 6px 18px;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 12px;
          letter-spacing: 0.5px;
        }
        .contact-header h2 {
          font-size: 2.6rem;
          font-weight: 800;
          color: var(--gray-900);
          margin-bottom: 8px;
        }
        .contact-header h2 span { color: var(--primary); position: relative; }
        .contact-header h2 span::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--primary-light);
          border-radius: 2px;
          z-index: -1;
        }
        .contact-header p { font-size: 1.1rem; color: var(--gray-500); max-width: 600px; margin: 0 auto; }
        .service-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          max-width: 960px;
          margin: 0 auto 40px;
        }
        .service-card {
          background: white;
          padding: 28px 20px;
          border-radius: 16px;
          text-align: center;
          border: 2px solid var(--gray-200);
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
        }
        .service-card:hover {
          border-color: var(--primary-light);
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
        }
        .service-card.active {
          border-color: var(--primary);
          box-shadow: 0 4px 20px rgba(37, 99, 235, 0.15);
          background: var(--gray-50);
        }
        .service-card.active::after {
          content: '✓ Selected';
          position: absolute;
          top: 12px;
          right: 12px;
          background: var(--primary);
          color: white;
          padding: 2px 12px;
          border-radius: 50px;
          font-size: 0.65rem;
          font-weight: 600;
        }
        .service-icon { font-size: 2.5rem; color: var(--primary); margin-bottom: 12px; }
        .service-card h4 { font-size: 1.1rem; font-weight: 700; color: var(--gray-800); margin-bottom: 4px; }
        .service-card > p { font-size: 0.85rem; color: var(--gray-500); margin-bottom: 12px; }
        .service-card ul { list-style: none; padding: 0; text-align: left; margin-bottom: 16px; }
        .service-card ul li { padding: 3px 0; font-size: 0.85rem; color: var(--gray-600); }
        .service-select-btn {
          display: inline-block;
          padding: 6px 20px;
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 600;
          color: var(--primary);
          border: 2px solid var(--primary);
          transition: all 0.3s ease;
        }
        .service-card.active .service-select-btn,
        .service-card:hover .service-select-btn {
          background: var(--primary);
          color: white;
        }
        .contact-wrapper {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 40px;
          margin: 20px 0;
        }
        .contact-info-box {
          background: var(--gray-50);
          padding: 32px 28px;
          border-radius: var(--radius-lg);
          border: 1px solid var(--gray-200);
        }
        .contact-info-box h3 { font-size: 1.3rem; font-weight: 700; color: var(--gray-900); margin-bottom: 4px; }
        .contact-info-box > p { color: var(--gray-500); font-size: 0.95rem; margin-bottom: 20px; }
        .contact-info-item {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          padding: 14px 0;
          border-bottom: 1px solid var(--gray-200);
        }
        .contact-info-item:last-child { border-bottom: none; }
        .contact-icon-wrapper {
          width: 44px;
          height: 44px;
          background: var(--primary-light);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: var(--primary);
          font-size: 1.2rem;
          transition: all 0.3s ease;
        }
        .contact-info-item:hover .contact-icon-wrapper {
          background: var(--primary);
          color: white;
          transform: scale(1.05);
        }
        .contact-info-item h4 { font-weight: 600; font-size: 0.95rem; color: var(--gray-800); }
        .contact-info-item p { color: var(--gray-500); font-size: 0.9rem; }
        .contact-cta { margin-top: 20px; padding-top: 16px; border-top: 2px solid var(--gray-200); text-align: center; }
        .contact-cta p { font-weight: 600; color: var(--gray-700); margin-bottom: 10px; }
        .call-btn { display: inline-flex; align-items: center; gap: 8px; padding: 10px 24px; font-size: 0.95rem; }
        .contact-form-box {
          background: white;
          padding: 32px;
          border-radius: var(--radius-lg);
          border: 1px solid var(--gray-200);
        }
        .contact-form-box h3 { font-size: 1.4rem; font-weight: 700; color: var(--gray-900); margin-bottom: 4px; }
        .form-subtitle { color: var(--gray-500); margin-bottom: 20px; font-size: 0.95rem; }
        .form-group { margin-bottom: 16px; }
        .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .form-group input, .form-group select, .form-group textarea {
          width: 100%;
          padding: 14px 18px;
          border: 2px solid var(--gray-200);
          border-radius: 12px;
          font-size: 0.95rem;
          font-family: inherit;
          transition: all 0.3s ease;
          background: var(--gray-50);
          appearance: none;
        }
        .form-group select {
          cursor: pointer;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 16px center;
        }
        .form-group input:focus, .form-group select:focus, .form-group textarea:focus {
          outline: none;
          border-color: var(--primary);
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
          background: white;
        }
        .form-group textarea { resize: vertical; min-height: 120px; }
        .submit-btn { width: 100%; justify-content: center; padding: 16px; font-size: 1.05rem; }
        .submit-btn:disabled { opacity: 0.7; cursor: not-allowed; }
        .spinner { animation: spin 1s linear infinite; }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @media (max-width: 1024px) {
          .service-cards { grid-template-columns: repeat(3, 1fr); gap: 16px; }
          .contact-header h2 { font-size: 2.2rem; }
        }
        @media (max-width: 768px) {
          .service-cards { grid-template-columns: 1fr; max-width: 400px; }
          .form-row { grid-template-columns: 1fr; }
          .contact-wrapper { grid-template-columns: 1fr; }
          .contact-header h2 { font-size: 1.8rem; }
          .contact-info-box { padding: 24px 20px; }
          .contact-form-box { padding: 24px 20px; }
          .notification-toast { max-width: 90%; right: 10px; top: 10px; padding: 12px 18px; font-size: 0.9rem; }
        }
        @media (max-width: 480px) {
          .contact-header h2 { font-size: 1.4rem; }
          .contact-header p { font-size: 0.95rem; }
          .contact-icon-wrapper { width: 38px; height: 38px; font-size: 1rem; }
          .service-card { padding: 20px 16px; }
          .contact-cta .call-btn { width: 100%; justify-content: center; }
        }
      `}</style>
    </div>
  );
};

export default Contact;